import { useState } from 'react';
import { SpecsLogo } from './SpecsLogo';
import { Button } from './Button';
import './Splash.css';

interface SplashProps {
  onSignIn: () => void | Promise<void>;
}

/**
 * Signed-out landing screen. Replaces the app header entirely when logged out:
 * the brand gradient (shared with the header via --genai-sem-header-bg-gradient)
 * fills the whole page, overlaid with a static fractal-noise grain, and the
 * welcome card floats centered on it with the Sign-in call to action.
 */
export function Splash({ onSignIn }: SplashProps) {
  const [pending, setPending] = useState(false);

  function handleSignIn() {
    if (pending) return;
    setPending(true);
    Promise.resolve(onSignIn()).catch(() => setPending(false));
  }

  return (
    <div className="splash">
      <main className="splash__content">
        <div className="card splash__card">
          {/* Decorative — the "Welcome to Specs-Ray" heading names the app. */}
          <span className="specs-logo welcome-card__logo">
            <SpecsLogo />
          </span>
          <h1 className="splash__heading">Welcome to Specs-Ray</h1>
          <p className="splash__lede">
            Sign in with your Cox Automotive credentials to view team
            dashboards, scan repositories, and track maturity scores.
          </p>
          <Button
            variant="primary"
            className="splash__signin"
            onClick={handleSignIn}
            disabled={pending}
            aria-busy={pending}
          >
            {pending ? 'Signing you in…' : 'Sign in'}
          </Button>
        </div>
      </main>
    </div>
  );
}
